import React, { useEffect } from "react";
import pdf from "../assests/data/Premisin_brochures.pdf";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HubspotForm from "react-hubspot-form";

const Hero = () => {
  const navigate = useNavigate();
  const [details, setDetails] = useState({
    email: "",
    mobile: "",
    name: "",
    check: "",
  });

  const [cap1, setCap1] = useState("");
  const [cap2, setCap2] = useState("");
  const [mess, setMess] = useState("");

  useEffect(() => {
    const otp = Math.floor(1 + Math.random() * 9);
    const otp2 = Math.floor(1 + Math.random() * 9);
    setCap1(otp);
    setCap2(otp2);
  }, []);

  const total = cap1 + cap2;
  const downloadBro = () => {
    window.gtag("event", "button_click_brocher");
    const link = document.createElement("a");
    link.href = pdf;
    link.download = "Premisin brochures.pdf";
    link.click();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFormSUbmit = async (e) => {
    e.preventDefault();
    if (details.check == total) {
      setMess("processing...");

      await axios
        .post("https://landing.premisin.com/reactSubmit.php", {
          name: details.name,
          email: details.email,
          mobile: details.mobile,
          action: "top",
        })
        .then((response) => {
          setMess(response.data.message);

          if (response.data.status === 1) {
            setDetails({ name: "", email: "", mobile: "" });
            navigate("/thankyou");
            setMess(response.data.message);
            window.gtag("event", "conversion", {
              send_to: "AW-10896336864/HC9qCKTrsLoDEODP48so",
              // event_callback: callback,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          setMess("Something went wrong");
        });
    } else {
      setMess("Please Enter Correct Addition.");
    }
  };

  return (
    <>
      <section className="u-py-md-250 u-flex-center startup-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-3 mb-lg-0 ">
              <h1 className="display-4 u-fw-600">
                <span className="text-primary">
                  Move to Premium Office Space For Rent In Raipur
                </span>
              </h1>
              <p className="u-fs-22 u-lh-1_8 mt-3">
                Are you tired of the same old office routine? It's time to make
                a change.
              </p>

              <p className="u-fs-22 u-lh-1_6 mt-3">
                Embrace the future with our fully furnished dedicated offices
                and co working spaces, meticulously designed to enhance your
                work experience like never before.
              </p>

              <p className="u-fs-22 u-lh-1_7 mt-3">
                From spacious layouts to ergonomic furniture, we've crafted an
                environment that fuels creativity, innovation, and networking,
                propelling your business to new heights.
              </p>

              <div className=" mb-3">
                <span style={{ fontSize: "24px" }} className="mr-1">
                  <b>Excellent</b>
                </span>

                <span style={{ fontSize: "15px" }} className=" p-1">
                  <i
                    className="fa fa-star text-warning fa-2x"
                    aria-hidden="true"
                  ></i>
                </span>
                <span style={{ fontSize: "15px" }} className=" p-1">
                  <i
                    className="fa fa-star text-warning fa-2x"
                    aria-hidden="true"
                  ></i>
                </span>
                <span style={{ fontSize: "15px" }} className=" p-1">
                  <i
                    className="fa fa-star text-warning fa-2x"
                    aria-hidden="true"
                  ></i>
                </span>
                <span style={{ fontSize: "15px" }} className=" p-1">
                  <i
                    className="fa fa-star text-warning fa-2x"
                    aria-hidden="true"
                  ></i>
                </span>
                <span style={{ fontSize: "15px" }} className=" p-1">
                  <i
                    className="fa fa-star text-warning fa-2x"
                    aria-hidden="true"
                  ></i>
                </span>

                <span className="ml-1" style={{ fontSize: "24px" }}>
                  <b>4.9 Rating on Google</b>
                </span>
              </div>

              <div className="row">
                <div className="col-md-6 col-6">
                  <a
                    href="#office-space"
                    data-scrollto="office-space"
                    className="btn btn btn-rounded btn-primary u-w-150 u-mt-30"
                    onClick={() =>
                      window.gtag("event", "button_click_know_more")
                    }
                  >
                    Know More
                  </a>
                </div>
                <div className="col-md-6 col-6" style={{ color: "white" }}>
                  <a
                    onClick={downloadBro}
                    className="btn btn btn-rounded btn-primary u-w-150 u-mt-30"
                  >
                    <i className="fa fa-download mr-1" aria-hidden="true"></i>
                    Brochures
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-5 mb-5 mb-lg-0 ">
              <div className="card box-shadow-v2 bg-white u-of-hidden text-center  mob-q">
                <h2 className="bg-primary m-0 py-3 text-white">
                  Get Your Office Quote Now!
                </h2>
                <div className="p-4 p-md-5">
                  <div style={{ marginBottom: '-105px' }}>
                    <HubspotForm
                      portalId='7848680'
                      formId='cf71a51e-2ec0-4e62-a181-7c1ef898b72b'
                      onSubmit={() => console.log('Submit!')}
                      onReady={(form) => console.log('Form ready!')}
                      loading={<div>Loading...</div>}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
